import { Deserializable } from '../interfaces';

export class Address implements Deserializable {
  country: string;
  zipCode: string;
  state: string;
  city: string;
  address: string;
  constructor() {
    this.country = '';
    this.zipCode = '';
    this.state = '';
    this.city = '';
    this.address = '';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
